module.exports = __webpack_public_path__ + "static/media/install-livechat.ddeaf980.svg";